import { Injectable } from '@angular/core';
import {Router} from '@angular/router';
import { NgXCookies } from 'ngx-cookies';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { environment } from '../environments/environment';
import { AuthService } from './auth.service';
import * as mime from 'mime-types';



@Injectable()
export class DossierService {

  constructor(private _http: Http, private _authService: AuthService) { }

  public generatePDF(resource, obj, isSecured, contentType) {
    // # Header with acces token
    let body: any;
    body = obj;
    const headers = new Headers({'Content-type': contentType});
    // if the request is secured, send the access_token
    if (isSecured) {
      headers.append('x-access-token' , this._authService.getAccesToken());
    }
    let urlSearchParams = new URLSearchParams();
    if ( contentType !== 'application/json; charset=utf-8') {
      urlSearchParams = this.appendParams(urlSearchParams, obj);
      body = urlSearchParams;
    }
    const options = new RequestOptions({ headers: headers, responseType: ResponseContentType.Blob  });
    let response;

      response = this._http.post(environment.apiEndpoint + resource, body, options);

    return response
                   .map((res: Response) => {
                    return new Blob([res.blob()], { type: 'application/pdf' })
                   })
                   .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }
  

  // append object attribute to the urlsearch parameter
  appendParams(params: URLSearchParams, obj: any) {
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        params.append(key, obj[key]);
      }
    }
    return params;
  }

  /**
   * upload files
   * @param resource
   * @param obj
   * @param isSecured
   * @param contentType
   */
  public uploadFiles(formData, id) {
    // # Header with acces token
    let body: any;
    const headers = new Headers();
    // if the request is secured, send the access_token
    headers.append('x-access-token' , this._authService.getAccesToken());
    const options = new RequestOptions({ headers: headers });
    let response;
    response = this._http.post(environment.apiEndpoint + environment.uploadFiles + '/'+ id,formData, options);
    return response
                   .map((res: Response) => res.json())
                   .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  public uploadCVFiles(formData, id) {
    // # Header with acces token
    let body: any;
    const headers = new Headers();
    // if the request is secured, send the access_token
    headers.append('x-access-token' , this._authService.getAccesToken());
    const options = new RequestOptions({ headers: headers });
    let response;
    response = this._http.post(environment.apiEndpoint + environment.uploadCVFiles + '/'+ id,formData, options);
    return response
                   .map((res: Response) => res.json())
                   .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  //Uplaoder un fichier dans le bilan annuel
  public uploadFileBilanAnnuel(formData, id, idBilan) {
    // # Header with acces token
   
    const headers = new Headers();
    // if the request is secured, send the access_token
    headers.append('x-access-token' , this._authService.getAccesToken());
    const options = new RequestOptions({ headers: headers});

    let response;
    response = this._http.post(environment.apiEndpoint + environment.uploadFileBilanAnnuel + '/'+ id + '/'+ idBilan, formData, options);
    return response
                   .map((res: Response) => res.json())
                   .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  //Supprimer le fichier attaché au bilan annuel
  public deleteFileBilanAnnuel(id, fileName, idBilan){
    let body = {
      id : id,
      fileName : fileName,
      idBilan : idBilan
    };
    const headers = new Headers();
    headers.append('x-access-token' , this._authService.getAccesToken());
    headers.append('Content-Type','application/json');
    const options = new RequestOptions({ headers: headers});
    return this._http.post(environment.apiEndpoint + environment.deleteFileBilanAnnuel ,body,options)
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  

  public downloadFile(id, fileName){
    let body = {
      id : id,
      fileName : fileName
    };
    const headers = new Headers();
    headers.append('x-access-token' , this._authService.getAccesToken());
    headers.append('Content-Type','application/json');
    const options = new RequestOptions({ headers: headers, responseType : ResponseContentType.Blob });
    let response;
    return this._http.post(environment.apiEndpoint + environment.downloadFile ,body,options)
    .map((res: Response) => {
          return new Blob([res.blob()], {type :  mime.lookup(fileName) })
       })
    .catch((error) => {return 'error'});


  }

  public downloadCVFile(id, fileName){
    let body = {
      id : id,
      fileName : fileName
    };
    const headers = new Headers();
    headers.append('x-access-token' , this._authService.getAccesToken());
    headers.append('Content-Type','application/json');
    const options = new RequestOptions({ headers: headers, responseType : ResponseContentType.Blob });
    let response;
    return this._http.post(environment.apiEndpoint + environment.downloadCVFile ,body,options)
    .map((res: Response) => {
          return new Blob([res.blob()], {type :  mime.lookup(fileName) })
       })
    .catch((error) => {return 'error'});
  }


  public deleteFile(id, fileName){
    let body = {
      id : id,
      fileName : fileName
    };
    const headers = new Headers();
    headers.append('x-access-token' , this._authService.getAccesToken());
    headers.append('Content-Type','application/json');
    const options = new RequestOptions({ headers: headers});
    return this._http.post(environment.apiEndpoint + environment.deleteFile ,body,options)
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  public deleteCVFile(id, fileName){
    let body = {
      id : id,
      fileName : fileName
    };
    const headers = new Headers();
    headers.append('x-access-token' , this._authService.getAccesToken());
    headers.append('Content-Type','application/json');
    const options = new RequestOptions({ headers: headers});
    return this._http.post(environment.apiEndpoint + environment.deleteCVFile ,body,options)
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }
}





// WEBPACK FOOTER //
// ./src/app/dossier.service.ts